import {
  HolidayAndWayOfWorkingRequestCode,
  RequirementsRequestCode,
} from '@doda/api-client/aspida/@types';
import { SEARCH_PICKUP_CONDITION_OPTIONS } from 'constants/searchCondition';
import { PickUpConditionListType } from 'types/pickUpConditions';
import { SearchPickUpCondition } from 'components/SearchSideBar/SearchPickUpCondition';
import { UpdateJobCountType } from 'components/SearchSideBar/types';
import { ChangeEvent, FC, memo } from 'react';
import { ConditionsAreaWrapper } from 'components/SearchSideBar/ConditionsAreaWrapper';
import { SidebarSection } from 'components/SearchSideBar/SidebarSection';

/**
 * Props
 * @param list 表示用配列
 * @param updateIsCheckedIsNewArrival 新着のチェックボックス更新処理
 * @param updateIsCheckedIsNearDeadline 締め切り間近のチェックボックス押下処理
 * @param updateIsCheckedHolidayAndWayOfWorkingList 休日・働き方のチェックボックス押下処理
 * @param updateIsCheckedRequirementList 応募・採用情報のチェックボックス押下処理
 * @param updateJobCount 求人件数更新処理
 * @param onChangeIsShowOverlay オーバーレイ表示処理
 */
interface Props {
  list: PickUpConditionListType[];
  updateIsCheckedIsNewArrival: (event: ChangeEvent<HTMLInputElement>) => void;
  updateIsCheckedIsNearDeadline: (event: ChangeEvent<HTMLInputElement>) => void;
  updateIsCheckedHolidayAndWayOfWorkingList: (
    event: ChangeEvent<HTMLInputElement>
  ) => HolidayAndWayOfWorkingRequestCode[];
  updateIsCheckedRequirementList: (
    event: ChangeEvent<HTMLInputElement>
  ) => RequirementsRequestCode[];
  updateJobCount: UpdateJobCountType;
  onChangeIsShowOverlay: () => void;
}

export const PickUpConditions: FC<Props> = memo(
  ({
    list,
    updateIsCheckedIsNewArrival,
    updateIsCheckedIsNearDeadline,
    updateIsCheckedHolidayAndWayOfWorkingList,
    updateIsCheckedRequirementList,
    updateJobCount,
    onChangeIsShowOverlay,
  }) => {
    return (
      <SidebarSection title={SEARCH_PICKUP_CONDITION_OPTIONS.title}>
        <ConditionsAreaWrapper>
          <SearchPickUpCondition
            list={list}
            updateIsCheckedIsNewArrival={updateIsCheckedIsNewArrival}
            updateIsCheckedIsNearDeadline={updateIsCheckedIsNearDeadline}
            updateIsCheckedHolidayAndWayOfWorkingList={
              updateIsCheckedHolidayAndWayOfWorkingList
            }
            updateIsCheckedRequirementList={updateIsCheckedRequirementList}
            updateJobCount={updateJobCount}
            onChangeIsShowOverlay={onChangeIsShowOverlay}
          />
        </ConditionsAreaWrapper>
      </SidebarSection>
    );
  }
);

PickUpConditions.displayName = 'PickUpConditions';
